import React, { useEffect, useState } from 'react';
import { Box, Button, Card, Divider, styled, Typography } from '@mui/material';
import { Icon } from '@iconify/react';
import DialogItemsList from './DialogItemsList';
import DialogItemCreate from './DialogItmeCreate';
import CardSelectedItem from './CardSelectedItem';
import { useDispatch } from 'react-redux';
import {
  getDialogItemCreateFuncAction,
  getDialogItemListFuncAction,
  getSelectCreateFuncs,
  resetSelectCreateFunctions
} from '../../../redux/slices/selectCreateComponent';

const CustomBox = styled(Box)(() => ({
  marginTop: '15px',
  marginBottom: '15px',
  display: 'flex',
  gap: '15px',
  justifyContent: 'center'
}));

function SelectCreate({ selectCreateId = 'comp1', createComponent, listItems, showedProps = [] }) {
  const [openItemsList, setOpenItemsList] = useState(false);
  const [openItemCreate, setOpenItemCreate] = useState(false);
  const dispatch = useDispatch();

  const onCloseItemList = (value) => {
    setOpenItemsList(value);
  };

  const onCloseItemCreate = (value) => {
    setOpenItemCreate(value);
  };

  useEffect(() => {
    dispatch(resetSelectCreateFunctions());

    const selectCreateFunctions = {
      selectCreateId,
      itemsListHandler: setOpenItemsList,
      itemCreateHandler: setOpenItemCreate
    };
    // dispatch(getDialogItemListFuncAction(onCloseItemList));
    // dispatch(getDialogItemCreateFuncAction(onCloseItemCreate));

    dispatch(getSelectCreateFuncs(selectCreateFunctions));
  }, [dispatch, selectCreateId]);
  return (
    <Card sx={{ padding: '10px' }}>
      <Typography variant="subtitle1" textAlign="center">
        Titulo
      </Typography>

      <CustomBox>
        <>
          <Button
            variant="contained"
            color="info"
            onClick={() => setOpenItemsList(true)}
            endIcon={<Icon icon="eva:search-fill" />}
          >
            Buscar
          </Button>
          <DialogItemsList open={openItemsList} onClose={setOpenItemsList} listItems={listItems} />
        </>

        <>
          <Button
            variant="contained"
            color="error"
            onClick={() => setOpenItemCreate(true)}
            endIcon={<Icon icon="eva:plus-outline" />}
          >
            Agregar
          </Button>
          <DialogItemCreate open={openItemCreate} onClose={setOpenItemCreate} createComponent={createComponent} />
        </>
      </CustomBox>

      <Divider />

      <Box>
        <Box padding="0 15px">
          <Typography variant="subtitle2" marginTop="15px">
            Item seleccionado:
          </Typography>
        </Box>
        <CardSelectedItem selectCreateId={selectCreateId} showedProps={showedProps} />
      </Box>
    </Card>
  );
}

export default SelectCreate;
